/**
 * @generated SignedSource<<470b297b02996119345441e9ef758433>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type accountsDropdown_CurrentUserFragment$data = {
  readonly accounts: ReadonlyArray<{
    readonly id: string;
    readonly name: string;
  }>;
  readonly " $fragmentType": "accountsDropdown_CurrentUserFragment";
};
export type accountsDropdown_CurrentUserFragment$key = {
  readonly " $data"?: accountsDropdown_CurrentUserFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"accountsDropdown_CurrentUserFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "accountsDropdown_CurrentUserFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Account",
      "kind": "LinkedField",
      "name": "accounts",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "CurrentUser",
  "abstractKey": null
};

(node as any).hash = "74639441828b4766e946799aa2852647";

export default node;
